import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../services/axios";
// import {getData} from '../Components/Helper';

const getEventsQueryParams = (
  filteredData,
  selectedDate,
  selectedCity,
  userBaseCity,
  view = "upcoming-events",
  coordinates = null,
) => {
  const queryParams = new URLSearchParams();
  const locality = filteredData?.locality
    ?.filter((item) => item.checked)
    .map((item) => item.value)
    ?.join("|");
  const artistType = filteredData?.artistType || "";

  const hasValidCoordinates =
    coordinates &&
    Number.isFinite(coordinates?.latitude) &&
    Number.isFinite(coordinates?.longitude);
  const coordinatesStr = hasValidCoordinates
    ? [coordinates.latitude, coordinates.longitude].join(",")
    : null;

  queryParams.append("upcoming", 1);
  queryParams.append("view", view);
  if (locality) queryParams.append("locality", locality);
  if (selectedDate) queryParams.append("date", selectedDate);
  if (selectedCity) queryParams.append("city", selectedCity);
  if (userBaseCity) queryParams.append("userBaseCity", userBaseCity);
  if (artistType) queryParams.append("artistType", artistType);
  if (coordinatesStr) queryParams.append("coordinates", coordinatesStr);

  return queryParams;
};

export const useFetchEvents = (
  filteredData,
  selectedDate,
  selectedCity,
  userBaseCity,
  enabled = true,
  coordinates = null
) => {
  return useInfiniteQuery({
    queryKey: [
      "api/events",
      { filteredData, selectedDate, selectedCity, userBaseCity, coordinates },
    ],
    queryFn: async ({ pageParam = 0 }) => {
      const queryParams = getEventsQueryParams(
        filteredData,
        selectedDate,
        selectedCity,
        userBaseCity,
        "upcoming-events",
        coordinates
      );
      const token = localStorage.getItem("userToken");
      let jsonToken = null;
      try {
        jsonToken = token ? JSON.parse(token) : null;
      } catch {
        jsonToken = token;
      }
      const { data } = await api.get(
        `api/events?page=${pageParam}&${queryParams}`,
        {
          headers: {
            Authorization: jsonToken ? `Bearer ${jsonToken}` : null,
          },
        }
      );

      if (data?.ok === false) {
        throw new Error(data?.message || "Something went wrong");
      }

      return data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.cursor ?? lastPage.nextCursor ?? undefined;
    },
    placeholderData: {},
    enabled: !!enabled,
  });
};
